module.exports = __webpack_public_path__ + "static/media/01-PICKUP-CABINET.4a98a598.png";